/* this file is transformed by vux-loader */
/* eslint-disable */
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.map.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Actionsheet from "vux/src/components/actionsheet/index.vue";
import Devices from '@/utils/ntConfig';
var startTime = 0;
var endTime = 0;

var noop = function noop(e) {
  return console.log(e);
};

export default {
  name: 'Tab',
  components: {
    Actionsheet: Actionsheet
  },
  data: function data() {
    return {
      isShow: false,
      num: 5,
      condition: false,
      title: this.$route.meta.name || document.title || '智服云',
      left: {
        control: false,
        onSuccess: [],
        onFail: noop,
        text: ''
      },
      right: {
        show: true,
        onSuccess: noop,
        onFail: noop,
        items: []
      }
    };
  },
  watch: {
    'left.control': function leftControl(v) {
      if (!v) {
        this.left.onSuccess = []; // if (this.left.onSuccess.length > 0) {
        //   this.left.control = true;
        // }
      }
    },
    '$route.meta.name': function $routeMetaName(val) {
      console.log(val);
      this.title = val;
    }
  },
  computed: {
    returnStyle: function returnStyle() {
      return {
        height: this.right.items.length * 40 + 'px'
      };
    },
    vuxMenu: function vuxMenu() {
      return this.right.items.map(function (v) {
        return {
          label: v.text,
          text: v.text,
          id: v.id
        };
      }).concat(Devices.platform === 'Android' ? [{
        label: '退出应用',
        text: '退出应用',
        id: 'quit'
      }] : []);
    },
    showRightIcon: function showRightIcon() {
      return this.right.items.length === 1 && this.right.items[0].url;
    }
  },
  created: function created() {
    Devices.biz.navigation.setRight = this.setRight;
    Devices.biz.navigation.setMenu = this.setMenu;
    Devices.biz.navigation.setLeft = this.setLeft;
    document.addEventListener('backbutton', this.onClickLeft.bind(this), false);
  },
  methods: {
    rightClick: function rightClick() {
      if (this.vuxMenu.length) {
        this.isShow = true;
      }
    },
    // eslint-disable-next-line
    setLeft: function setLeft() {
      var option = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        control: control,
        text: text,
        onSuccess: onSuccess,
        onFail: onFail
      };

      for (var key in option) {
        if (key === 'onSuccess') {
          // 左边后退功能的缓存
          this['left'][key].unshift(option[key]);
        } else {
          this['left'][key] = option[key];
        }
      }

      if (this.left.text) {
        this.title = this.left.text;
      }
    },
    // eslint-disable-next-line
    setMenu: function setMenu() {
      var option = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        items: items,
        onSuccess: onSuccess,
        onFail: onFail
      };

      for (var key in option) {
        this.$set(this.right, key, option[key]);
      }

      this.right.show = true;
    },
    setRight: function setRight(_ref) {
      var show = _ref.show;
      this.right.show = show;

      if (show === false) {
        this.right.items = [];
      }
    },
    onClickLeft: function onClickLeft() {
      function eventBackButton() {
        endTime = new Date().getTime();

        if (endTime - startTime < 200) {
          navigator.app.exitApp();
        } else {
          startTime = new Date().getTime();
        }
      }

      if (this.$route.name === 'Home') {
        eventBackButton();
      }

      if (this.left.control) {
        try {
          // 左边后退功能的缓存
          this.left.onSuccess[0]();
        } catch (error) {
          this.left.onFail ? this.left.onFail() : this.$router.back();
        }
      } else {
        this.$router.back();
      }
    },
    onClickRight: function onClickRight(item) {
      try {
        if (item.id === 'quit') {
          navigator.app.exitApp();
        } else {
          this.right.onSuccess(item);
        }
      } catch (error) {
        this.left.onFail();
      }
    },
    menuSelect: function menuSelect(key, menu) {
      this.onClickRight(menu);
    }
  }
};